class ProductCardSwatchHover {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('pointerover', this.handleSwatchHover.bind(this), false);
    document.addEventListener('pointerout', this.handleSwatchLeave.bind(this), false);
    document.addEventListener('click', this.handleSwatchClick.bind(this), false);
    document.addEventListener('click', this.handleOutsideClick.bind(this), false);
  }

  normalizeTitleCapitalization(variantTitle, originalTitle) {
    if (!variantTitle || !originalTitle) return variantTitle;
    
    // Titulky přeložené automatikou používají pomlčku, čeština spojovník.
    // Bez téhle detekce split selže a barva se k názvu přilepí místo nahrazení,
    // takže titulek na hoveru povyroste a karta poskočí.
    const separatorOf = (title) => (title.includes(' \u2013 ') ? ' \u2013 ' : ' - ');
    const originalSeparator = separatorOf(originalTitle);
    const variantSeparator = separatorOf(variantTitle);

    const originalParts = originalTitle.split(originalSeparator);
    const variantParts = variantTitle.split(variantSeparator);

    if (originalParts.length > 1 && variantParts.length > 1) {
      const baseTitle = variantParts.slice(0, -1).join(variantSeparator);
      const variantColor = variantParts[variantParts.length - 1];
      const originalColor = originalParts[originalParts.length - 1];

      if (originalColor === originalColor.toLowerCase()) {
        return baseTitle + variantSeparator + variantColor.toLowerCase();
      }
    }
    
    return variantTitle;
  }

  getMobileSliderFirstImage(productCard) {
    const firstSlide = productCard.querySelector('.product-card__mobile-slide:first-child');
    return firstSlide ? firstSlide.querySelector('img') : null;
  }

  updateImages(productCard, variantImageUrl) {
    const variantImageSizes = this.generateImageSizes(variantImageUrl);

    const mainImage = productCard.querySelector('.product-card__image--main img');
    if (mainImage) {
      mainImage.src = variantImageUrl;
      mainImage.srcset = variantImageSizes.srcset;
    }

    const mobileSliderImage = this.getMobileSliderFirstImage(productCard);
    if (mobileSliderImage) {
      mobileSliderImage.src = variantImageUrl;
      mobileSliderImage.srcset = variantImageSizes.srcset;
    }
  }

  storeOriginalImages(productCard) {
    const mainImage = productCard.querySelector('.product-card__image--main img');
    if (mainImage && !mainImage.dataset.originalSrc) {
      mainImage.dataset.originalSrc = mainImage.src;
      mainImage.dataset.originalSrcset = mainImage.srcset || '';
    }

    const mobileSliderImage = this.getMobileSliderFirstImage(productCard);
    if (mobileSliderImage && !mobileSliderImage.dataset.originalSrc) {
      mobileSliderImage.dataset.originalSrc = mobileSliderImage.src;
      mobileSliderImage.dataset.originalSrcset = mobileSliderImage.srcset || '';
    }
  }

  revertImages(productCard) {
    const mainImage = productCard.querySelector('.product-card__image--main img');
    if (mainImage && mainImage.dataset.originalSrc) {
      mainImage.src = mainImage.dataset.originalSrc;
      mainImage.srcset = mainImage.dataset.originalSrcset;
    }

    const mobileSliderImage = this.getMobileSliderFirstImage(productCard);
    if (mobileSliderImage && mobileSliderImage.dataset.originalSrc) {
      mobileSliderImage.src = mobileSliderImage.dataset.originalSrc;
      mobileSliderImage.srcset = mobileSliderImage.dataset.originalSrcset;
    }
  }

  handleSwatchHover(event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (!event.target || typeof event.target.closest !== 'function') return;
    
    const swatchElement = event.target.closest('[data-swatch-hover]');
    if (!swatchElement) return;

    const productCard = swatchElement.closest('.product-card');
    if (!productCard) return;

    if (productCard.classList.contains('swatch-click-active')) return;

    const variantImageUrl = swatchElement.dataset.variantImage;
    if (!variantImageUrl) return;

    this.storeOriginalImages(productCard);

    const swatchLink = swatchElement.querySelector('a, .swatch-color');
    const variantTitle = swatchLink ? (swatchLink.title || swatchLink.getAttribute('aria-label') || '') : '';

    const titleElement = productCard.querySelector('.product-card__title a');
    if (titleElement && !titleElement.dataset.originalTitle) {
      titleElement.dataset.originalTitle = titleElement.textContent;
    }

    this.updateImages(productCard, variantImageUrl);
    
    if (titleElement && variantTitle) {
      const normalizedTitle = this.normalizeTitleCapitalization(variantTitle, titleElement.dataset.originalTitle || titleElement.textContent);
      titleElement.textContent = normalizedTitle;
    }
    
    productCard.classList.add('swatch-hover-active');
  }

  handleSwatchLeave(event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (!event.target || typeof event.target.closest !== 'function') return;
    
    const swatchElement = event.target.closest('[data-swatch-hover]');
    if (!swatchElement) return;

    const productCard = swatchElement.closest('.product-card');
    if (!productCard) return;

    if (productCard.classList.contains('swatch-click-active')) return;

    const mainImage = productCard.querySelector('.product-card__image--main img');
    const mobileSliderImage = this.getMobileSliderFirstImage(productCard);
    if ((!mainImage || !mainImage.dataset.originalSrc) && (!mobileSliderImage || !mobileSliderImage.dataset.originalSrc)) return;

    this.revertImages(productCard);
    
    const titleElement = productCard.querySelector('.product-card__title a');
    if (titleElement && titleElement.dataset.originalTitle) {
      titleElement.textContent = titleElement.dataset.originalTitle;
    }
    
    productCard.classList.remove('swatch-hover-active');
  }

  handleSwatchClick(event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    
    const swatchLink = event.target.closest('[data-swatch-hover] a, [data-swatch-hover] .swatch-color');
    if (!swatchLink) return;

    const swatchElement = swatchLink.closest('[data-swatch-hover]');
    if (!swatchElement) return;

    const productCard = swatchElement.closest('.product-card');
    if (!productCard) return;

    const variantImageUrl = swatchElement.dataset.variantImage;
    if (!variantImageUrl) return;

    event.preventDefault();
    event.stopPropagation();

    this.storeOriginalImages(productCard);

    const variantUrl = swatchLink.href || swatchLink.closest('a')?.href;
    const variantTitle = swatchLink.title || swatchLink.getAttribute('aria-label') || '';

    const titleElement = productCard.querySelector('.product-card__title a');
    if (titleElement && !titleElement.dataset.originalTitle) {
      titleElement.dataset.originalTitle = titleElement.textContent;
      titleElement.dataset.originalHref = titleElement.href;
    }

    const productLinks = productCard.querySelectorAll('a[href*="/products/"]:not(.product-card__swatches a)');
    productLinks.forEach(link => {
      if (!link.dataset.originalHref) {
        link.dataset.originalHref = link.href;
      }
    });

    const isAlreadySelected = swatchElement.classList.contains('swatch-selected');

    document.querySelectorAll('.product-card').forEach(card => {
      if (card !== productCard) {
        card.classList.remove('swatch-click-active');
        
        const otherTitleElement = card.querySelector('.product-card__title a');
        if (otherTitleElement && otherTitleElement.dataset.originalTitle) {
          otherTitleElement.textContent = otherTitleElement.dataset.originalTitle;
          otherTitleElement.href = otherTitleElement.dataset.originalHref;
        }
        
        const otherLinks = card.querySelectorAll('a[href*="/products/"]:not(.product-card__swatches a)');
        otherLinks.forEach(link => {
          if (link.dataset.originalHref) {
            link.href = link.dataset.originalHref;
          }
        });
      }
    });

    productCard.querySelectorAll('[data-swatch-hover]').forEach(swatch => {
      swatch.classList.remove('swatch-selected');
    });

    if (isAlreadySelected) {
      if (variantUrl) {
        window.location.href = variantUrl;
      }
      return;
    }

    this.updateImages(productCard, variantImageUrl);
    
    if (titleElement && variantTitle) {
      const normalizedTitle = this.normalizeTitleCapitalization(variantTitle, titleElement.dataset.originalTitle || titleElement.textContent);
      titleElement.textContent = normalizedTitle;
      titleElement.href = variantUrl;
    }

    if (variantUrl) {
      productLinks.forEach(link => {
        link.href = variantUrl;
      });
    }
    
    productCard.classList.add('swatch-click-active');
    productCard.classList.remove('swatch-hover-active');
    
    swatchElement.classList.add('swatch-selected');

    swatchElement.dataset.href = variantUrl;
  }

  handleOutsideClick(event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    
    const clickedSwatch = event.target.closest('[data-swatch-hover]');
    if (clickedSwatch) return;
    
    const clickedCard = event.target.closest('.product-card');
    
    if (clickedCard && clickedCard.classList.contains('swatch-click-active')) {
      const clickedLink = event.target.closest('a');
      if (clickedLink && !clickedLink.closest('.product-card__swatches')) {
        return;
      }
    }
    
    if (!clickedCard || !clickedCard.classList.contains('swatch-click-active')) {
      document.querySelectorAll('.product-card.swatch-click-active').forEach(card => {
        this.resetCardState(card);
      });
    }
  }

  resetCardState(card) {
    card.classList.remove('swatch-click-active');
    
    const titleElement = card.querySelector('.product-card__title a');
    if (titleElement && titleElement.dataset.originalTitle) {
      titleElement.textContent = titleElement.dataset.originalTitle;
      titleElement.href = titleElement.dataset.originalHref;
    }
    
    const productLinks = card.querySelectorAll('a[href*="/products/"]:not(.product-card__swatches a)');
    productLinks.forEach(link => {
      if (link.dataset.originalHref) {
        link.href = link.dataset.originalHref;
      }
    });
    
    this.revertImages(card);
    
    card.querySelectorAll('[data-swatch-hover]').forEach(swatch => {
      swatch.classList.remove('swatch-selected');
    });
  }

  generateImageSizes(baseUrl) {
    const baseUrlWithoutParams = baseUrl.split('?')[0];
    const widths = [70, 140, 165, 355, 450, 535, 710, 900, 1070, 1420];
    
    const srcsetArray = widths.map(width => {
      const url = `${baseUrlWithoutParams}?width=${width}`;
      return `${url} ${width}w`;
    });
    
    return {
      srcset: srcsetArray.join(', ')
    };
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardSwatchHover();
  });
} else {
  new ProductCardSwatchHover();
} 